import { motion, AnimatePresence } from 'motion/react';
import { ReactNode } from 'react';

interface SheetProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  side: 'left' | 'right';
  title?: string;
}

export default function Sheet({ isOpen, onClose, children, side }: SheetProps) {
  const isLeft = side === 'left';

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Mobile overlay */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-ink/20 backdrop-blur-sm z-40 lg:hidden"
          />

          {/* Panel */}
          <motion.div
            initial={{ x: isLeft ? '-100%' : '100%' }}
            animate={{ x: 0 }}
            exit={{ x: isLeft ? '-100%' : '100%' }}
            transition={{ type: 'spring', stiffness: 400, damping: 35 }}
            className={`
              sheet-panel fixed bottom-0 z-50 shadow-2xl flex flex-col
              ${isLeft ? 'left-0 w-[260px]' : 'right-0 w-[300px] max-w-[85vw]'}
              lg:static lg:bottom-auto lg:h-full lg:w-auto
              lg:bg-transparent lg:shadow-none lg:z-auto
              bg-ink
            `}
          >
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}